export const icons = {
	"add-photozone": "&#xe9d4",
	"add-textzone": "&#xe9d5",
	"angle-left": "&#xe025;",
	"angle-left-slim": "&#xe9c4",
	"angle-right": "&#xe024;",
	"arrow-left": "&#xe98a;",
	"bring-to-back": "&#xe9d2",
	"bring-to-front": "&#xe9d3",
	"calendar-day": "&#xe9e3",
	"calendar-star": "&#xe9e2",
	"check-circle": "&#xe9be",
	"dots-horizontal": "&#xe980;",
	"dots-vertical": "&#xe980;",
	"less-than": "&#xe007;",
	"low-res": "&#xe9ca",
	"map": "&#xe9f9",
	"magic-staff": "&#xe9c5;",
	"not-available": "&#xe9e0;",
	"paint-background-color": "&#xe9b9",
	"paint-background-pattern": "&#xe9ba",
	"paint-background-photo": "&#xe9bb",
	"paint-bucket": "&#xe990;",
	"paint-text": "&#xe9b5;",
	"pencil-brush": "&#xe95e;",
	"photo-brightness": "&#xe9cf",
	"photo-contrast": "&#xe9ce",
	"photo-filter": "&#xe9c6",
	"photo-saturation": "&#xe9cd",
	"photo-selection": "&#xe9b7;",
	"photo-sliders": "&#xe9cc",
	"photo-transform": "&#xe9d6",
	"plus-circle": "&#xe9a5;",
	"shopping-bag-gift": "&#xe9c7;",
	"shopping-cart-plus": "&#xe9a2;",
	"spread-overview": "&#xe9eb",
	"text-align-center": "&#xe985;",
	"text-align-left": "&#xe986;",
	"text-align-right": "&#xe988;",
	"text-color": "&#xe98f",
	"text-edit": "&#xe999",
	"text-size": "&#xe99e",
	"text-style-bold": "&#xe98b",
	"text-style-italic": "&#xe993",
	"text-style-underline": "&#xe99a;",
	"text-valign-bottom": "&#xe9b1;",
	"text-valign-middle": "&#xe9b2;",
	"text-valign-top": "&#xe9b3;",
	"zoom-in": "&#xe99c",
	"zoom-out": "&#xe99d",
	backward: "&#xe9d0",
	bin: "&#xe9a8;",
	calendar: "&#xe9d7",
	camera: "&#xe032;",
	check: "&#xe98d",
	copy: "&#xe9cb;",
	cross: "&#xe98c;",
	designs: "&#xe9b8",
	device: "&#xe9ab;",
	font: "&#xe9a1;",
	forward: "&#xe9d1",
	frame: "&#xe9a7;",
	help: "&#xe016;",
	info: "&#xe9bd;",
	menu: "&#xe992;",
	minus: "&#xe994;",
	move: "&#xe9a9;",
	offline: "&#xe99f;",
	options: "&#xe9bf",
	pencil: "&#xe9e1;",
	photo: "&#xe9b0;",
	plus: "&#xe995;",
	preview: "&#xe01a;",
	redo: "&#xe996;",
	restart: "&#xe9a3;",
	rotate: "&#xe9ac;",
	save: "&#xe997;",
	scale: "&#xe9ad;",
	shapes: "&#xe98e;",
	shuffle: "&#xe9ae;",
	sliders: "&#xe9a6;",
	smartphoto: "&#xe021;",
	symbols: "&#xe9dc;",
	templates: "&#xe9b6;",
	text: "&#xe998;",
	undo: "&#xe99b;",
	zoom: "&#xe013;",
};

export type IconName = keyof typeof icons;
